import React from "react";
import { DropdownOptions } from "../dropdownOptions";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
interface Props {
  selectedOptions: DropdownOptions[] | null;
  onOptionRemoved: (removedOption: DropdownOptions) => unknown;
}
export const MultiSelectedOptions = ({
  selectedOptions,
  onOptionRemoved,
}: Props) => {
  return (
    <div
      className="flex flex-row flex-wrap gap-3 content-center items-center overflow-hidden mb-2"
      style={{ width: "92%" }}
    >
      {(selectedOptions || []).map((option: DropdownOptions) => {
        return (
          <div
            className="rounded-md flex pt-1 pb-1 pr-2 pl-2 content-center items-center"
            style={{
              backgroundColor: Colors.TangerineOrange,
              color: Colors.White,
              height: "26px",
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
          >
            <div className="flex flex-1 p-1">
              <div
                className="text-sm"
                style={{ fontFamily: FontFamily.ROBOTO_BOLD }}
              >
                {" "}
                {option?.text}
              </div>
            </div>
            <div
              onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                onOptionRemoved(option);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                width="12px"
                height="12px"
                fill={Colors.White}
              >
                <path
                  d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  stroke={Colors.White}
                  strokeWidth="1"
                />
              </svg>

              {/* <img src={CrossIcon} alt={'cross'} /> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};
